import { render } from "./RequestPage.vue?vue&type=template&id=3b0d592e"
import script from "./RequestPage.vue?vue&type=script&lang=js"
export * from "./RequestPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__